import { motion } from 'framer-motion';

export default function ExperienceSection() {
  return (
    <section id="experience" className="section experience" aria-labelledby="experience-heading">
      <div className="container">
        <p className="eyebrow">Selected experience</p>
        <h2 id="experience-heading" className="section-heading">The work I’ve loved most.</h2>
        <p className="section-intro">Some of my more recent and, honestly, favorite work.</p>

        <div className="feature-grid">
          <motion.article className="feature" initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.35 }}>
            <p className="feature__eyebrow">Capital One / Summer 2026</p>
            <h3>Product Management &amp; Analytics Intern</h3>
            <p>As a PM&amp;A intern, I got to build my own tool to test whether new credit-bureau datasets added information beyond the variables already in our models.
            </p>
            <ul className="feature__list">
              <li>Built Python and SQL pipelines to distinguish redundant variables from new predictive signals.</li>
              <li>Estimated a 40 bps AUC lift and $5M NPV through in-time/out-of-time validation and CART residual analysis.</li>
              <li>Turned the work into stakeholder-ready HTML dashboards with Claude Code.</li>
            </ul>
          </motion.article>

          <motion.article className="feature feature--accent" initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.35, delay: 0.08 }}>
            <p className="feature__eyebrow">Personal project / 2026</p>
            <h3>Algorithmic event-driven trading bot</h3>
            <p>
              For this project, I built a trading algorithm around early NBA injury news. Teams typically publish injury reports before a game, but NBA insiders sometimes post the same updates hours earlier.
              Most of the time, the market has already reacted. You can usually see a noticeable spike in purchase volume for the team that benefits, but once in a while there is still an edge.
              The markets are small and position sizes are limited, so it is more of a systems-and-markets project than a major profit opportunity.
            </p>
            <ul className="feature__list">
              <li>Built event parsing, price-impact estimation, and live-market execution into one pipeline.</li>
              <li>Used a rolling three-hour WebSocket price filter to flag and suppress potential pre-event insider activity.</li>
              <li>Validated the strategy through live execution and 48-hour backtest windows.</li>
            </ul>
            <a className="feature__link" href="https://github.com/rafaelperales05/kalshi-bot.git" target="_blank" rel="noreferrer">Explore the bot on GitHub ↗</a>
          </motion.article>
        </div>
      </div>
    </section>
  );
}
